module.exports = __webpack_public_path__ + "static/media/perks.a9b16dba.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/plans/images/perks.png
// module id = 1646
// module chunks = 0